module.exports = __webpack_public_path__ + "static/media/Taliyah.4021c7ce.png";